import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MetaQuality from './MetaQuality';

export const MetaQualities = ({ qualitiesPossessedList }) => (
  <div>
    <h2 className="heading heading--2">Metaqualities</h2>
    <ul className="metaqualities__list">
      {qualitiesPossessedList && qualitiesPossessedList.map(quality => (
        <MetaQuality key={quality.id} data={quality} />
      ))}
    </ul>

  </div>
);

MetaQualities.propTypes = {
  qualitiesPossessedList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = ({
  settings: { data: { qualitiesPossessedList } },
}) => ({ qualitiesPossessedList });

export default connect(mapStateToProps)(MetaQualities);
